import defaultTransformer from '../default/transformer'
import textTransformer from '../text/transformer'
import richTextTransformer from '../richText/transformer'
import numberTransformer from '../number/transformer'
import dropselectTransformer from '../dropselect/transformer'
import areaTransformer from '../area/transformer'
import standardTransformer from '../standard/transformer'
import mediaTransformer from '../media/transformer'
import attachmentTransformer from '../attachment/transformer'
import datetimeTransformer from '../datetime/transformer'
import orgTransformer from '../org/transformer'
import userTransformer from '../user/transformer'
import gisTransformer from '../gis/transformer'

const typesMap = {
  default: defaultTransformer,
  text: textTransformer,
  richText: richTextTransformer,
  number: numberTransformer,
  dropSelect: dropselectTransformer,
  area: areaTransformer,
  standard: standardTransformer,
  media: mediaTransformer,
  attachment: attachmentTransformer,
  datetime: datetimeTransformer,
  org: orgTransformer,
  user: userTransformer,
  gis: gisTransformer,
}

const dealValue = (defs, rowData, events, hooks) => {
  // const transformer = typesMap[defs.renderType]
  const { productSlugs } = defs
  if (!productSlugs || !productSlugs.length) {
    return null
  }
  return productSlugs.map((slug) => {
    const currentField =
      defs.productFields.find((field) => field.slug === slug) || {}
    let obj = {}
    if (typesMap[currentField.type]) {
      const _transformer = typesMap[currentField.type]
      obj = _transformer(rowData[slug], currentField, rowData, events, hooks)
    }

    return obj
  })
}

const transformer = function (origin, defs, rowData, events, hooks) {
  const { payload } = defs || {}
  const { rawRowData } = payload || {}

  const renders = dealValue(defs, rawRowData || rowData, events, hooks)

  return {
    render: defs.renderType,
    origin,
    value: (renders && renders.map((v) => v.value)) || origin,
    rowData: rawRowData || rowData,
    fields: defs.productFields || [], // 暂时先这样吧
  }
}

export default transformer
